import { render } from "./ObjectDeletion.vue?vue&type=template&id=1ad4ae64&scoped=true"
import script from "./ObjectDeletion.vue?vue&type=script&lang=js"
export * from "./ObjectDeletion.vue?vue&type=script&lang=js"

import "./ObjectDeletion.vue?vue&type=style&index=0&id=1ad4ae64&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ad4ae64"

export default script